<template>
  <div
    class="absolute inset-0 z-[9999] flex flex-col items-center justify-center gap-8 bg-white px-8 text-center"
  >
    <Spinner />
    <div class="flex max-w-2xl flex-col gap-3">
      <h1 class="text-2xl font-semibold text-neutral-900 [text-wrap:balance]">
        {{ $t("app-update.title") }}
      </h1>
      <p class="text-base text-neutral-500">
        {{ $t("app-update.text") }}
      </p>
    </div>
    <p
      class="rounded-full bg-neutral-100 px-5 py-2 text-sm font-medium text-neutral-500"
    >
      {{ $t("app-update.do-not-refresh") }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Spinner from "@/components/common/Spinner.vue";

export default defineComponent({
  name: "RefreshApp",
  components: { Spinner },
});
</script>
